import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import { getProjectBudget } from '@/service/operate/budgetReport';
export default function useProjectBudget(params) {
  var projectBudget = ref({
    totalYsje: 0,
    totalYssyje: 0,
    projectBudgetList: []
  });
  // 查询时间范围内停机详情
  var getProjectBudgetAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getProjectBudget(params.value);
          case 2:
            data = _context.sent;
            if (data) {
              projectBudget.value = data;
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getProjectBudgetAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var projectBudgetTotal = computed(function () {
    return [{
      num: projectBudget.value.totalYsje,
      desc: '总预算金额/元'
    }, {
      num: projectBudget.value.totalYssyje,
      desc: '总预算剩余/元'
    }];
  });
  var projectBudgetData = computed(function () {
    return {
      pieData: projectBudget.value.projectBudgetList.map(function (item) {
        return {
          name: item.zxfymc,
          value: item.ysje
        };
      }).filter(function (item) {
        return item.value;
      }),
      unit: '元',
      customTooltip: true,
      tooltipFormatter: function tooltipFormatter(params) {
        return "\n          <div >\n            <div class=\"flex align-start\">\n              <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n              <div>\n                <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                <div>\n                 <span style=\"font-size: 12px;\">").concat(params.value, "\u5143</span>\n                </div>\n              </div>\n            </div>\n          </div>\n          ");
      }
    };
  });
  return [projectBudgetTotal, projectBudgetData, getProjectBudgetAsync];
}